// extracted by mini-css-extract-plugin
export default {"logOutput":"DataProcessLog_logOutput__cG5w1","logOutputItemTimestamp":"DataProcessLog_logOutputItemTimestamp__Z+7Mn","selectionTime":"DataProcessLog_selectionTime__jZku+"};